import { withDataId } from '@hocs/with-data-id'
import Button, { type ButtonProps } from '@ui/atoms/button'
import { Link, type LinkProps } from '@ui/atoms/link'
import { LinkUnstyled, type LinkUnstyledProps } from '@ui/link-unstyled'
import { isExternal } from '@utils/is-external'
import { isSubscriptionLink } from '@utils/links'
import {
  type HTMLAttributesExtended,
  withLinkProps,
} from '@utils/with-link-props'
import { type ComponentType, type FC } from 'react'

import { withEspaceClientLinkSupport } from '../../../../plugins/gatsby-plugin-espace-client'
import { type EnhancedComponentExtendedProps } from './types'

// TODO: enrich all components with tracking and data-test-* values
const withEspaceClient = <T extends EnhancedComponentExtendedProps>(
  Component: ComponentType<T>
): FC<T & HTMLAttributesExtended> =>
  withEspaceClientLinkSupport<T>(Component, isSubscriptionLink, isExternal)

const withAll = <T extends EnhancedComponentExtendedProps>(
  Component: ComponentType<T>
): FC<T & HTMLAttributesExtended> =>
  withDataId(withLinkProps(withEspaceClient(Component)))

export const EnhancedButton = withAll<ButtonProps>(Button)
export const EnhancedLink = withAll<LinkProps>(Link)
export const EnhancedLinkUnstyled = withAll<LinkUnstyledProps>(LinkUnstyled)
